module.exports = __webpack_public_path__ + "img/details.4dbd74b3.png";